// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const sideNavClasses = {
  branch: "qui-side-nav__branch-root",
  branchContent: "qui-side-nav__branch-content",
  branchIndentGuide: "qui-side-nav__branch-indent-guide",
  branchTrigger: "qui-side-nav__branch-trigger",
  collapseTrigger: "qui-side-nav__collapse-trigger",
  divider: "qui-side-nav__divider",
  filterInput: "qui-side-nav__filter-input",
  group: "qui-side-nav__group",
  groupLabel: "qui-side-nav__group-label",
  header: "qui-side-nav__header",
  headerAction: "qui-side-nav__header-action",
  headerLogo: "qui-side-nav__header-logo",
  headerTitle: "qui-side-nav__header-title",
  nodeAccessory: "qui-side-nav__node-accessory",
  nodeAction: "qui-side-nav__node-action",
  nodeIcon: "qui-side-nav__node-icon",
  nodeIndicator: "qui-side-nav__node-indicator",
  nodeRoot: "qui-side-nav__node-root",
  root: "qui-side-nav__root",
} as const
